/* istanbul ignore file */
import { appendReduxPart } from "infrastructure/store";

import TermDictionary from "./TermDictionary";
import { termDictionarySaga } from "./TermDictionary.saga";
import { termDictionary } from "./TermDictionary.slice";

export * from "./TermDictionary.actions";
export * from "./TermDictionary.state";
export * from "./TermDictionary.slice";

export { TermDictionary };

appendReduxPart(
  {
    reducerName: termDictionary.name,
    reducer: termDictionary.reducer
  },
  termDictionarySaga()
);
